var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkedinW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.803,
    height: 15.769,
    viewBox: "0 0 15.803 15.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin_1_",
    "data-name": "linkedin (1)",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M11.457,164.715H8.385a.247.247,0,0,0-.247.247v9.869a.247.247,0,0,0,.247.247h3.072a.247.247,0,0,0,.247-.247v-9.869A.247.247,0,0,0,11.457,164.715Z",
    transform: "translate(-7.895 -159.809)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M2.027.563A2.025,2.025,0,1,0,4.053,2.588,2.028,2.028,0,0,0,2.027.563Z",
    transform: "translate(0 -0.563)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M181.5,156.508a3.608,3.608,0,0,0-2.7,1.133V157a.247.247,0,0,0-.247-.247h-2.942a.247.247,0,0,0-.247.247v9.869a.247.247,0,0,0,.247.247h3.065a.247.247,0,0,0,.247-.247v-4.883c0-1.645.447-2.286,1.594-2.286,1.249,0,1.348,1.028,1.348,2.371v4.8a.247.247,0,0,0,.247.247h3.066a.247.247,0,0,0,.247-.247v-5.413C185.423,159.009,184.957,156.508,181.5,156.508Z",
    transform: "translate(-170.121 -151.847)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedinW);
export default __webpack_public_path__ + "static/media/icon-linkedin-w.18d3f47bb4dc09329b7b3338f4eec292.svg";
export { ForwardRef as ReactComponent };